import { useMemo } from "react"

const useMonitoringProgramProgress = ({ data }) => {
  const status = data?.current_status?.status

  const startMonthObj = data?.timeline?.find((month) => month.recovery_month_number === 1)
  const startMonth = startMonthObj?.month
  const startYear = startMonthObj?.year

  const endMonthObj = data?.timeline?.find(
    (month) => month.month === startMonth + data?.current_status?.recovery_progress?.total - 1
  )
  const endMonth = endMonthObj?.month
  const endYear = endMonthObj?.year

  const programProgress =
    ((data?.current_status?.recovery_progress?.current - 1) /
      data?.current_status?.recovery_progress?.total || 0.05) * 100
  const totalLength = data?.timeline?.length
  const programLength = endMonth - startMonth + 1
  const startDate = new Date(startYear, startMonth - 1)
  const endDate = new Date(endYear, endMonth)

  const isShowProgressBar =
    status === "under_monitoring" && startMonth && endMonth && programLength > 0

  const timeLineSegments = useMemo(() => {
    const segments = []

    if (startMonth > 1) {
      segments.push({
        progress: 0,
        width: ((startMonth - 1) / totalLength) * 100 + "%"
      })
    }
    segments.push({
      progress: programProgress,
      width: (programLength / totalLength) * 100 + "%"
    })

    if (endMonth < totalLength) {
      segments.push({
        progress: 0,
        width: ((totalLength - endMonth) / totalLength) * 100 + "%"
      })
    }
    return segments
  }, [data])

  const edgesIntervalWidth = (programLength / totalLength) * 100 + "%"
  const edgesStartOffset = ((startMonth - 1) / totalLength) * 100 + "%"
  const isFinishTextHidden = endMonth >= totalLength

  return {
    isShowProgressBar,
    timeLineSegments,
    startDate,
    endDate,
    edgesIntervalWidth,
    edgesStartOffset,
    isFinishTextHidden
  }
}

export default useMonitoringProgramProgress
